import { StyledLine } from './_styled/line.styled'

export default StyledLine
